export default "__VITE_ASSET__B5PFdqr9__"